<!--
  @component Navbar.MenuGroup

  A component that represents a group of menu items within the navbar.
  It provides a way to organize and structure menu items in the mobile menu or dropdown menus.

  @prop label - The accessible label for the menu group (required)
  @prop css - Custom CSS styles to apply to the menu group

  Example:
  <Navbar.MenuGroup label="User Actions">
    <Navbar.MenuItem href="/profile" label="Profile" />
    <Navbar.MenuItem href="/settings" label="Settings" />
  </Navbar.MenuGroup>
-->

<script lang="ts">
  import { css } from '@agapi/ui/panda/css';
  import { menuStyles } from '../navbar.styles';
  import type { NavbarMenuGroupProps } from '../navbar.types';

  /**
   * Props for the Navbar.MenuGroup component
   */
  const { label, children, css: cssProp }: NavbarMenuGroupProps = $props();

  const styles = menuStyles.raw();
</script>

<ul class={css(styles.group, cssProp)} role="menu" aria-label={label}>
    {@render children?.()}
</ul>
